// extracted by mini-css-extract-plugin
export var drawerContent = "_35-0";
export var valueBlock = "_35-1";
export var valueBlockFrom = "_35-2 _35-1";
export var valueBlockTo = "_35-3 _35-1";